<div class="modal-header">
  <h5 class="modal-title">{{initialState.fromTag ? 'Save Tag' : (initialState.data ? 'Edit Story Prompt' : 'New Story Prompt')}}</h5>
  <button type="button" (click)="close()" class="close"><span aria-hidden="true">
      <svg role="img">
        <use xlink:href="#icon-close"></use>
      </svg></span></button>
</div>

<div class="modal-body pb-0" [formGroup]="updateForm">
  <div class="row mb-4" >
    <div class="col-12">
      <div class="tag-field" *ngIf="useChips">
        <div class="tag-field__head">
          <span>Tags</span>
          <span>{{tagChips.length}} {{tagChips.length === 1 ? 'tag' : 'tags'}}</span>
        </div>
        <div class="tag-box" [class.tag-box--invalid]="!!duplicateError" (click)="chipInput.focus()">
          <div class="tag-box__main">
          <div #chipList class="tag-box__chips" *ngIf="tagChips.length" [class.tag-box__chips--collapsed]="!chipBoxExpanded">
            <span class="tag-chip" *ngFor="let chip of chipStates; let i = index; trackBy: trackByIndex" [class.tag-chip--invalid]="chip.invalid" [class.tag-chip--editing]="editingChipIndex === i" (click)="startChipEdit(i, $event)">
              <svg *ngIf="chip.invalid && editingChipIndex !== i" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="6.2" stroke="currentColor" stroke-width="1.4"/><path d="M8 4.6v4.2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><circle cx="8" cy="11.2" r="0.7" fill="currentColor"/></svg>
              <input *ngIf="editingChipIndex === i" class="tag-chip__edit" [style.width.ch]="chipEditWidth"
                [ngModel]="editingChipValue" (ngModelChange)="editingChipValue = $event" [ngModelOptions]="{standalone: true}"
                (keydown)="onChipEditKeydown($event)" (blur)="commitChipEdit()" (click)="$event.stopPropagation()" aria-label="Edit tag">
              <ng-container *ngIf="editingChipIndex !== i">{{chip.name}}</ng-container>
              <button type="button" class="tag-chip__remove" (click)="removeChip(i, $event)" [attr.aria-label]="'Remove ' + chip.name">×</button>
            </span>
          </div>
          <input #chipInput class="tag-box__input" [ngModel]="tagDraft" (ngModelChange)="onChipDraftChange($event, chipInput)" [ngModelOptions]="{standalone: true}"
            [placeholder]="tagChips.length ? 'Add another tag' : 'Type a tag and press Enter'" (keydown)="onChipKeydown($event)" (paste)="onChipPaste($event)" (blur)="commitDraft()">
          </div>
          <button type="button" class="tag-box__expand" *ngIf="chipsOverflow" (click)="toggleChipBox($event)" [attr.aria-label]="chipBoxExpanded ? 'Collapse tag list' : 'Expand tag list'" [attr.title]="chipBoxExpanded ? 'Collapse' : 'Expand'">
            <svg *ngIf="!chipBoxExpanded" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M9.5 2.5H13.5V6.5M6.5 13.5H2.5V9.5M13.2 2.8 9.2 6.8M2.8 13.2l4-4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <svg *ngIf="chipBoxExpanded" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M13.5 6.5H9.5V2.5M2.5 9.5H6.5V13.5M9.5 6.5l4-4M6.5 9.5l-4 4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
        </div>
        <button type="button" class="tag-box__toggle" *ngIf="chipsOverflow" (click)="toggleChipBox($event)">
          {{chipBoxExpanded ? 'Show fewer' : 'Show all ' + tagChips.length + ' tags'}}
          <svg [class.tag-box__toggle-icon--up]="chipBoxExpanded" class="tag-box__toggle-icon" width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <div class="tag-alert" *ngIf="invalidChipNotice">
          <div class="tag-alert__copy">
            <strong>{{invalidChipNotice.title}}</strong>
            <span>{{invalidChipNotice.detail}}</span>
          </div>
          <button type="button" class="tag-alert__remove" (click)="removeInvalidChips()">Remove</button>
        </div>
      </div>
      <gs-input-material *ngIf="!useChips" [label]="fieldLabel" name="Title" [placeholder]="fieldPlaceholder" isTextarea="true" rows="0" cssClass="spacing-lg"
        formControlName="title" [formControl]="updateForm.controls.title"></gs-input-material>
      <div class="tag-import" *ngIf="showImport">
        <p class="tag-import__label"><span>Or import</span></p>
        <div class="tag-import__actions">
          <button type="button" class="tag-import__button" (click)="openCsvUpload()" [disabled]="isImporting || isUpdating">
            <span class="tag-import__badge">
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 12.4V3.6M4.8 6.6 8 3.2l3.2 3.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </span>
            Upload CSV
          </button>
          <button type="button" class="tag-import__button" *ngIf="showCopy" (click)="copyTags()" [disabled]="isImporting || isUpdating" [attr.title]="'Import tags ' + copyLabel.toLowerCase()">
            <span class="tag-import__badge tag-import__badge--copy">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="8.2" y="8.2" width="11" height="11" rx="2" stroke="currentColor" stroke-width="2"/><path d="M15.8 6.2V5.2A2.2 2.2 0 0 0 13.6 3H5.2A2.2 2.2 0 0 0 3 5.2v8.4a2.2 2.2 0 0 0 2.2 2.2h1" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>
            </span>
            {{copyLabel}}
          </button>
        </div>
      </div>
    </div>
    <div class="warning-text wrap" *ngIf="promptTooLong">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      <p class="px-2 mb-0">Prompts can be up to {{maxPromptLength}} characters. This one has {{promptLength}}.</p>
    </div>
    <div class="warning-text wrap" *ngIf="saveError || (!useChips && duplicateError)">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      <p class="px-2 mb-0">{{saveError || duplicateError}}</p>
    </div>
    <div class="warning-text" *ngIf="!initialState.fromTag && initialState.data?.story_count > 0 && showEditWarning">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      <p class="px-2">Edit will update all published stories.</p>
    </div>
  </div>

  <div class="prompt-audience" *ngIf="!initialState.fromTag && initialState.showAudience">
    <p class="prompt-audience__label" id="prompt-audience-label">Who can be asked this prompt?</p>
    <div class="prompt-audience__options" role="radiogroup" aria-labelledby="prompt-audience-label">
      <label class="prompt-audience__option" *ngFor="let option of audienceOptions"
        [class.prompt-audience__option--selected]="updateForm.value.audience === option.value">
        <input type="radio" formControlName="audience" [value]="option.value">
        <span>{{option.label}}</span>
      </label>
    </div>
  </div>

  <div class="tag-import prompt-import" *ngIf="showPromptImport">
    <p class="tag-import__label"><span>Have a list already?</span></p>
    <div class="tag-import__actions">
      <button type="button" class="tag-import__button" (click)="openPromptImport()" [disabled]="isUpdating">
        <span class="tag-import__badge">
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 12.4V3.6M4.8 6.6 8 3.2l3.2 3.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </span>
        Import prompts from CSV
      </button>
    </div>
  </div>

  <div class="row mb-4" *ngIf="initialState.main_board">
    <label class="row mb-0 spacer ml-3">
      <div class="">
        <div class="form-group mb-4">
          <span class="switch">
            <input type="checkbox" formControlName="is_active">
            <span class="slider"></span>
          </span>
        </div>
      </div>
      <div class="">
        <div class="form-group mb-4 ml-2">Enable for Other Users</div>
      </div>
    </label>
  </div>
</div>


<div class="modal-footer">
  <p class="tag-modal__hint" *ngIf="useChips && duplicateError">Fix the highlighted tag to save</p>
  <div class="tag-modal__buttons">
    <button (click)="close()" type="button" data-dismiss="modal"
      class="btn btn-outline btn-gray-light tag-modal__action">Cancel</button>
    <button (click)="save()" [disabled]="isUpdating || IsDisabled" type="button" class="btn tag-modal__action tag-modal__save">
      <i *ngIf="isUpdating" class="fas fa-spinner fa-pulse"></i> Save
    </button>
  </div>
</div>